(function () {
	angular
		.module('trackeye')
		.directive('teNotification', NotificationDirective);

	NotificationDirective.$inject = ["$animate"];

	function NotificationDirective($animate) {
		return {
			restrict: "E",
			replace: true,
			templateUrl: '/partials/notification/template.html',
			link: function (scope, element, attributes) {
				element.addClass("is-" + attributes.notificationType);
				$animate.on('leave', element.parent(), function (element, phase) {
					if (phase == "close") {
						element.remove();
					}
				});

				scope.dismiss = function() {
					$animate.leave(element);
				};
			}
		}
	}
})();